import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { ActivityIndicator, Image, View } from 'react-native';
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import OrderGradeBar from '../../../Componentsv1/OrderGradeBar';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { event_getEventByEventId, event_getLatestPrices, event_getMatchByMatchId, event_getTournamentByTournamentId } from '../../../store/actionsv1/events';
import { social_getPlayerByPlayerId } from '../../../store/actionsv1/social';
import { PublicPlayerProps } from '../../../store/types/auth_svc';
import { MarketProps, OrderProps, PlayerFilterProps } from '../../../store/types/mk_svc';
import { EventProps, ExternalPriceProps, MatchProps, TournamentProps } from '../../../store/types/sr_svc';
import { market_getOddsLabel, market_getVar1Label } from '../../Event/helpers/markets';

type PromotedOrderCardProps = { 
    order:OrderProps, 
    player_filter:PlayerFilterProps,
    featured?:boolean, 
    height:number, 
    width:number, 
    onSelect?:any 
}

const PromotedOrderCard = ({ player_filter, order, featured, height, width, onSelect }:PromotedOrderCardProps) => {
    const [ cardSize, setCardSize ] = useState({ x:0, y:0, width:300, height:800 })
    const [ playerCardSize, setPlayerCardSize ] = useState({ x:0, y:0, width:300, height:200 })

    //Redux
    const dispatch = useDispatch();
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const event:EventProps|undefined = useSelector((state:any) => state.event.events[order.event_id], (left, right) => left?.event_id == right?.event_id)
    const tournament:TournamentProps|undefined = useSelector((state:any) => state.event.tournaments[order.event_id], (left, right) => left?.tournament_id == right?.tournament_id)
    const match:MatchProps|undefined = useSelector((state:any) => state.event.matches[order.event_id], (left, right) => left?.match_id == right?.match_id)
    const market:MarketProps|undefined = useSelector((state:any) => state.market.markets.find(m => m.market_id == order.market_id), (left, right) => left?.market_id == right?.market_id)
    const external_prices:ExternalPriceProps[] = useSelector((state:any) => state.event.latest_prices.filter((p:ExternalPriceProps) => p.event_id == order.event_id && p.event_type == order.event_type && p.market_id == order.market_id), (left, right) => left[0]?.external_price_id == right[0]?.external_price_id)
    const cl = order.market_type === 'FOR_MONEY' ? '$' : 'E'
    const order_player:PublicPlayerProps | undefined = useSelector((state:any) => state.social.stored_players.find(p => p.player_id == order.player_id), (left, right) => left?.player_id == right?.player_id)

    const findExternalPrice = () => {
        let eps:ExternalPriceProps[] = []
        if(player.type != 'premium'){ return undefined }
        switch(order.side_type){
            case 'event':
                eps = external_prices.filter(ep => ep.side == order.side)
                break
            case 'athlete':
                eps = external_prices.filter(ep => ep.participant_type == order.side_type && ep.participant_id == order.side_id && ep.side == order.side)
                break
            case 'team':
                eps = external_prices.filter(ep => ep.participant_type == order.side_type && ep.participant_id == order.side_id && ep.side == order.side)
                break
            default: break
        }
        let consensus_price = eps.find(p => p.external_name == 'Consensus');
        if(!order.live && player_filter.filter.external_book){
            let book_price = eps.find(p => p.external_name == player_filter.filter.external_book);
            if(book_price){
                consensus_price = book_price
            }
        }
        return consensus_price
    }

    const external_price = findExternalPrice();


    useEffect(() => {
        getDataFromServer()
    },[order.order_id, featured])

    const getDataFromServer = async() => {
        if(order.event_type === 'team' && !event){ await dispatch(event_getEventByEventId(order.event_id)) }
        if(order.event_type === 'tournament' && !tournament){ await dispatch(event_getTournamentByTournamentId(order.event_id)) }
        if(order.event_type === 'match' && !match){ await dispatch(event_getMatchByMatchId(order.event_id)) }
        if(featured){ 
            await dispatch(event_getLatestPrices(order.event_id, order.event_type, order.market_id, order.side, order.side_id)) 
        }
        await dispatch(social_getPlayerByPlayerId(order.player_id))
    }


    
    const handleSelect = () => {
        if(!onSelect){ return }
        onSelect(order)
    }

    const getEventTitle = () => {
        switch(order.event_type){
            case 'team':
                if(!event){ return '' }
                return event.event_title
            case 'tournament':
                if(!tournament){ return '' }
                return tournament.tournament_name
            case 'match':
                if(!match){return ''}
                return match.match_title
            default: return ''
        }
    }

    if(featured && height){
        return (
            <View style={{ backgroundColor: Colors.brand.electric, borderRadius:13, justifyContent:'space-between', width: width - 40, minHeight:height }} onLayout={(ev) => {
                const { height, width, x, y } = ev.nativeEvent.layout
                setCardSize({ height, width, x, y })
            }}>
                <View style={{ padding:10, flexDirection:'row', alignItems:'center' }}>
                    <View style={{ backgroundColor:Colors.brand.cyan, padding:10, borderRadius:8 }}>
                        <Image source={require('../../../assets/images/icon_sparkline.png')} style={{ height: 18, width:18 }} />
                    </View>
                    <View style={{ marginLeft:10 }}>
                        <Text size={14} weight='semibold' color={Colors.shades.white}>Open Order</Text>
                        <Text size={12} weight='regular' color={Colors.shades.white} style={{ marginTop:2 }}>Offer expires {moment(order.expire_datetime).fromNow()}</Text>
                    </View>
                </View>
                <View style={{ paddingLeft:20, paddingRight:20 }}>
                    <Text size={28} color={Colors.shades.white} weight='bold'>{order.title}</Text>
                    <Text size={14} color={Colors.shades.white} weight='regular'>{getEventTitle()}</Text>
                </View>
                <View style={{paddingLeft:20, paddingRight:20 }}>
                    <View style={{ flexDirection:'row', alignItems:'center'}}>
                        <View style={{ flex:1 }}>
                            <Text size={14} color={Colors.shades.white} weight='regular'>Offer Probability</Text>
                            <Text size={20} color={Colors.shades.white} weight='semibold'>{(order.probability*100).toFixed(2)}%</Text>
                        </View>
                        {market ?
                        <View style={{ flex:1 }}>
                            <Text size={14} color={Colors.shades.white} weight='regular'>Offer Odds</Text>
                            <Text size={20} color={Colors.shades.white} weight='semibold'>{market.var_1_required?`${market_getVar1Label(order.var_1, market)} `:''}({market_getOddsLabel(order.odds, 0)})</Text>
                        </View>
                        :<></>}
                    </View>
                    
                    <View style={{ flexDirection:'row', alignItems:'center', marginTop:10}}>
                        <View style={{ flex:1 }}>
                            <Text size={20} color={Colors.shades.white} weight='regular'>Grade</Text>
                        </View>
                        <View style={{ flex:1 }}>
                            <OrderGradeBar grade={order.grade} view_type='card'/>
                        </View>
                    </View>
                    
                    { external_price && market ?
                    <View style={{ flexDirection:'row', alignItems:'center', marginTop:10}}>
                        <View style={{ flex:1 }}>
                            <Text size={14} color={Colors.shades.white} weight='regular'>External Price</Text>
                            <Text size={20} color={Colors.shades.white} weight='semibold'>{external_price.external_name}</Text>
                        </View>
                        <View style={{ flex:1 }}>
                            <Text size={14} color={Colors.shades.white} weight='regular'>External Odds</Text>
                            <Text size={20} color={Colors.shades.white} weight='semibold'>{market.var_1_required?`${market_getVar1Label(external_price.var_1, market)}`:''} ({market_getOddsLabel(external_price.odds)})</Text>
                        </View>
                    </View>
                    : player.type != 'premium' ?
                    <View style={{ flexDirection:'row', alignItems:'center', marginTop:10}}>
                        <View style={{ flex:1 }}>
                            <Text size={14} color={Colors.shades.white} weight='regular'>External Price</Text>
                            <Text size={20} color={Colors.shades.white} weight='semibold'>Consensus</Text>
                        </View>
                        <View style={{ flex:1 }}>
                            <Text size={14} color={Colors.shades.white} weight='regular'>External Odds</Text>
                            <Text size={20} color={Colors.shades.white} weight='semibold'>Premium Access Only</Text>
                        </View>
                    </View>
                    :
                    <View style={{ marginTop:20, alignItems:'flex-start', justifyContent:'flex-start' }}>
                        <ActivityIndicator size='small' color={Colors.shades.white}/>
                    </View>
                    }
                </View>
                <View style={{ padding:10,paddingLeft:20, paddingRight:20, flexDirection:'row', alignItems:'center'}}>
                    <View style={{ flex:1 }}>
                        <Text size={14} color={Colors.shades.white} weight='regular'>Quantity</Text>
                        <Text size={28} color={Colors.shades.white} weight='semibold'>{cl}{order.open_amt.toFixed(2)}</Text>
                    </View>
                    <View style={{ flex:1 }}>
                        <Text size={14} color={Colors.shades.white} weight='regular'>Potential Winnings</Text>
                        <Text size={28} color={Colors.shades.white} weight='semibold'>{cl}{order.potential_winnings.toFixed(2)}</Text>
                    </View>
                </View>
                {order_player?
                <View>
                    <View style={[localStyles.shadowBox, { position:'absolute', backgroundColor:Colors.shades.white, borderBottomRightRadius:13, borderBottomLeftRadius:13, left:playerCardSize.x + 20, top:playerCardSize.y, height:playerCardSize.height + 20, width:playerCardSize.width - 40 }]} />
                    <View style={[localStyles.shadowBox, { position:'absolute', backgroundColor:Colors.shades.white, borderBottomRightRadius:13, borderBottomLeftRadius:13, left:playerCardSize.x + 10, top:playerCardSize.y, height:playerCardSize.height + 10, width:playerCardSize.width - 20 }]} />
                    <View style={[localStyles.shadowBox, { flexDirection:'row', alignItems:'center', backgroundColor:Colors.shades.white, borderRadius:13, padding:5, paddingTop:10, paddingBottom:10 }]}
                    onLayout={(ev) => {
                        const { height, width, x, y } = ev.nativeEvent.layout
                        setPlayerCardSize({ height, width, x, y })
                    }}>
                        <View style={{flex:1/5}}>
                            <Image source={order_player.profile_pic} style={{ borderRadius:100, height:40, width:40 }}/>
                        </View>
                        <View style={{flex:3/5}}>
                            <Text size={16} weight='semibold' color={Colors.brand.midnight}>{order_player.first_name} {order_player.last_name}</Text>
                            <Text size={14} weight='regular' color={Colors.brand.midnight}>@{order_player.username}</Text>
                        </View>
                        <View style={{flex:1/5}}>
                            <Icon name='map-pin' color={Colors.brand.midnight} size={16} type='feather'/>
                            <Text size={14} weight='regular' color={Colors.brand.slate}>{order.region}</Text>
                        </View>
                    </View>
                </View>
                :<></>}
                {order.live ?
                <View style={{ position:'absolute', top:-10, right:-5, padding:5, flexDirection:'row', alignItems:'center', backgroundColor:Colors.utility.error, borderRadius:100 }}>
                    <Icon name='zap' type='feather' color={Colors.shades.white} size={16} />
                    <Text size={12} color={Colors.shades.white} weight='regular' style={{marginLeft:5, marginRight:5}}>Live</Text>
                </View>
                :<></>}
                <View style={{position:'absolute', borderRadius:1000, backgroundColor:'rgba(255, 255, 255, 0.1)', height:cardSize.width, width:cardSize.width, top:-cardSize.width/2, left:-cardSize.width/2}} />
            </View>
        )
    }

    return (
        <TouchableOpacity style={{ flex:1, backgroundColor: Colors.brand.electric, margin:5, marginBottom:20, borderRadius:13, padding:10, paddingBottom:20, paddingTop:20, width:width / 2.5, minWidth:100, maxWidth:220 }} onLayout={(ev) => {
            const { x,y,width,height } = ev.nativeEvent.layout
            setCardSize({ x,y,height,width })
        }} onPress={() => handleSelect()}>
            <Text size={12} color={Colors.shades.white} textAlign='center' weight='semibold'>{order.title}</Text>
            <Text size={12} color={Colors.shades.white} textAlign='center' style={{marginTop:5}}>Offer Odds: {market_getOddsLabel(order.odds, 0)}</Text>
            <Text size={12} color={Colors.shades.white} textAlign='center' style={{marginTop:5}}>Quantity: {cl}{order.open_amt.toFixed(2)}</Text>
            <Text size={10} color={Colors.shades.white} weight='regular' textAlign='center' style={{marginTop:5}}>{getEventTitle()}</Text>       
            {order_player ?
            <View style={{ position:'absolute', flexDirection:'row', justifyContent:'center', alignItems:'center', bottom:2, left:2, height:22, width:22, backgroundColor:Colors.shades.white, borderRadius:100 }}>
                <Image source={order_player.profile_pic} style={{ borderRadius:100, height:20, width:20 }}/>
            </View>
            :<></>}
            {player?.type === 'premium'  ?
            <View style={{ padding:5, justifyContent:'center', alignItems:'center' }}>
                <OrderGradeBar view_type='card' grade={order.grade}/>
            </View>
            :<></>}
            {order.live ?
            <View style={{ position:'absolute', top:-10, left:-5, padding:5, flexDirection:'row', alignItems:'center', backgroundColor:Colors.utility.error, borderRadius:100 }}>
                <Icon name='zap' type='feather' color={Colors.shades.white} size={16} />
                <Text size={12} color={Colors.shades.white} weight='regular' style={{marginLeft:5, marginRight:5}}>Live</Text>
            </View>
            :<></>}
        </TouchableOpacity>
    )

    
}

const localStyles = {
    shadowBox: { shadowColor: "rgba(0, 0, 0, 0.16)", shadowOffset: { width: 0, height: 3 }, shadowRadius: 12, shadowOpacity: 1, elevation:5  }
}

export default PromotedOrderCard
